import {cutHeadImg, isArray} from '@/common/util/global';
let mutations = {
    days21CardInit(state, data) {
        // l1-l3为数组
        if (isArray(data.story.story)) {
            data.story.story.sort((a, b) => {
                return a.pn - b.pn
            });
            data.question.sort((a, b) => {
                return a.pn - b.pn
            });
            state.question = data.question;
            state.question_pages = data.question.length;
            state.storys = data.story.story;
            state.storys_pages = data.story.story.length;
            state.total_pages = data.question.length + (data.story.story.length - 1) * 2;
            state.total_days = (Number(data.training.period_id) - 1) * 21 + Number(data.training.day_id);
            state.cover_img = data.story.story[0].img;
            state.cover_title = data.story.story[0].title;
            state.cover_text = data.story.story[0].text;
            state.cover_audio = data.story.story[0].audio;
        }
        else {
            // state.higher = {
            //     course_video: {
            //         size: "1024",
            //         url: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1515380639572_030008010059C3809596D7131CB684565A498F-CDE9-3713-D57A-9D322669CE39.mp4"
            //     },
            //     template_video: {
            //         size: "1024",
            //         url: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1515380639572_030008010059C3809596D7131CB684565A498F-CDE9-3713-D57A-9D322669CE39.mp4"
            //     },
            //     core_words: [
            //         {
            //             "py_text": "第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849080970_L1-15-%25E6%25A0%2587%25E9%25A2%2598.mp3"
            //         },
            //         {
            //             "py_text":"第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849124054_15%25E6%2588%25BF%25E5%25AD%2590%25E7%259F%25AE.mp3"
            //         },
            //         {
            //             "py_text":"22第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849691993_15%25E6%25BC%2582%25E4%25BA%25AE.mp3"
            //         },
            //         {
            //             "py_text": "第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849080970_L1-15-%25E6%25A0%2587%25E9%25A2%2598.mp3"
            //         },
            //         {
            //             "py_text":"第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849124054_15%25E6%2588%25BF%25E5%25AD%2590%25E7%259F%25AE.mp3"
            //         },
            //         {
            //             "py_text":"22第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849691993_15%25E6%25BC%2582%25E4%25BA%25AE.mp3"
            //         },
            //         {
            //             "py_text": "第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849080970_L1-15-%25E6%25A0%2587%25E9%25A2%2598.mp3"
            //         },
            //         {
            //             "py_text":"第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849124054_15%25E6%2588%25BF%25E5%25AD%2590%25E7%259F%25AE.mp3"
            //         },
            //         {
            //             "py_text":"22第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849691993_15%25E6%25BC%2582%25E4%25BA%25AE.mp3"
            //         },
            //         {
            //             "py_text": "第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849080970_L1-15-%25E6%25A0%2587%25E9%25A2%2598.mp3"
            //         },
            //         {
            //             "py_text":"第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849124054_15%25E6%2588%25BF%25E5%25AD%2590%25E7%259F%25AE.mp3"
            //         },
            //         {
            //             "py_text":"22第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849691993_15%25E6%25BC%2582%25E4%25BA%25AE.mp3"
            //         },
            //         {
            //             "py_text": "第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849080970_L1-15-%25E6%25A0%2587%25E9%25A2%2598.mp3"
            //         },
            //         {
            //             "py_text":"第天了",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849124054_15%25E6%2588%25BF%25E5%25AD%2590%25E7%259F%25AE.mp3"
            //         },
            //         {
            //             "py_text":"最后一个词",
            //             "pinyin": [
            //                 {
            //                     "key": "第",
            //                     "py": "dì",
            //                     "pyfix": "dì"
            //                 },
            //                 {
            //                     "key": "天",
            //                     "py": "tiān",
            //                     "pyfix": "tiān"
            //                 },
            //                 {
            //                     "key": "了",
            //                     "py": "le",
            //                     "pyfix": "le"
            //                 }],
            //             "core_audio":"http:\/\/wxcp-img.oss-cn-beijing.aliyuncs.com\/1513849691993_15%25E6%25BC%2582%25E4%25BA%25AE.mp3"
            //         }
            //         ],
            //     title:"第七天",
            // };
            state.higher = data.story.story;
            state.cover_title = data.story.story.title;
            state.cover_text = data.story.text;
            state.cover_audio = data.story.audio;
        }


        //l1-l3 与 l7-l9公共数据
        state.user_audio = data.training && data.training.user_audio;   //l7-l9 新加
        state.user_weixin_audio = data.training && data.training.user_weixin_audio;
        state.status = data.status;
        state.share_id = data.training ? data.training.id : ''


        
        // state.question = [{
        //     answer: {
        //         A: {
        //             // img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810198096_%25E9%25BB%2598%25E8%25AE%25A4%25E6%25A0%2587%25E9%25A2%2598_%25E5%2585%25AC%25E4%25BC%2597%25E5%258F%25B7%25E5%25B0%2581%25E9%259D%25A2%25E5%25B0%258F%25E5%259B%25BE_2017.12.09.jpg", 
        //             audio: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810272241_L1-7-%25E6%25A0%2587%25E9%25A2%2598.mp3", 
        //             text: "坐、爬"
        //         },
        //         B: {
        //             // img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810991030_%25E5%25A4%25A7%25E7%2586%258A%25E7%258C%25AB%25E5%259D%2590%25E9%25A3%259E%25E6%259C%25BA.jpg", 
        //             audio: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810979989_L1-7-%25E5%259D%2590%25E9%25A3%259E%25E6%259C%25BA.mp3", 
        //             text: "坐、捉"
        //         },
        //         C: {
        //             // img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512811148650_1.jpg", 
        //             audio: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512811027187_7%25E5%259D%2590%25E6%25B1%25BD%25E8%25BD%25A6.mp3", 
        //             text: "做、捉"
        //         }
        //     },
        //     ask: {
        //         audio:"http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810485821_L1-5-%25E9%2597%25AE%25E7%25AD%2594.mp3",
        //         img: "",
        //         // img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512811018497_%25E5%25A4%25A7%25E7%2586%258A%25E7%258C%25AB%25E5%259D%2590%25E6%25B1%25BD%25E8%25BD%25A6.jpg",
        //         text: "今天学了哪两个动词？"
        //     },
        //     std_answer: "B",
        // },
        // {
        //     answer: {
        //         A: {
        //             img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810198096_%25E9%25BB%2598%25E8%25AE%25A4%25E6%25A0%2587%25E9%25A2%2598_%25E5%2585%25AC%25E4%25BC%2597%25E5%258F%25B7%25E5%25B0%2581%25E9%259D%25A2%25E5%25B0%258F%25E5%259B%25BE_2017.12.09.jpg", 
        //             audio: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810272241_L1-7-%25E6%25A0%2587%25E9%25A2%2598.mp3", 
        //             text: "坐、爬"
        //         },
        //         B: {
        //             img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810991030_%25E5%25A4%25A7%25E7%2586%258A%25E7%258C%25AB%25E5%259D%2590%25E9%25A3%259E%25E6%259C%25BA.jpg", 
        //             audio: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810979989_L1-7-%25E5%259D%2590%25E9%25A3%259E%25E6%259C%25BA.mp3", 
        //             text: "坐、捉"
        //         },
        //         C: {
        //             img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512811148650_1.jpg", 
        //             audio: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512811027187_7%25E5%259D%2590%25E6%25B1%25BD%25E8%25BD%25A6.mp3", 
        //             text: "做、捉"
        //         }
        //     },
        //     ask: {
        //         audio:"http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512810485821_L1-5-%25E9%2597%25AE%25E7%25AD%2594.mp3",
        //         img: "http://wxcp-img.oss-cn-beijing.aliyuncs.com/1512811018497_%25E5%25A4%25A7%25E7%2586%258A%25E7%258C%25AB%25E5%259D%2590%25E6%25B1%25BD%25E8%25BD%25A6.jpg",
        //         text: "今天学了哪两个动词？"
        //     },
        //     std_answer: "C",
        // }
        // ];

        state.demo_audio = data.training.demo_audio;
        state.period_id = Number(data.period_id);
        state.day_id = Number(data.day_id);    
        state.series_day = Number(data.training.series_day);
        state.during = Number(data.training.during);
        state.loves = data.loves;
        // 标记数据已经初始化
        state.inited = true;
    },
    days21CardUpdate(state, data) {
        state.share_id = data;    
    }
}
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/habitCard/mutations.js